/**
 * Dots joined by a line, the status above each dot (rotated), the date and user
 * below; the active dot is the last event, the ones after it are greyed.
 */
import type { TimelineItem } from './dms-logic';

export function HorizontalTimeline({
  items,
}: Readonly<{ items: readonly TimelineItem[] }>) {
  return (
    <div className="timeline" role="list" aria-label="Timeline">
      {items.map((item, index) => (
        <div
          key={`${item.top}-${index}`}
          role="listitem"
          className={`timeline-dot ${item.active ? 'active' : ''}`}
          data-testid="mtm-part-details-timeline-step"
          data-value={item.top}
          data-active={item.active ? 'true' : 'false'}
          aria-label={[item.top, item.bottom.replace('\n', ', ')]
            .filter(Boolean)
            .join(' ')}
        >
          <span
            data-top={item.top}
            data-bottom={item.bottom}
            style={{ color: item.topColor }}
          />
        </div>
      ))}
    </div>
  );
}
